/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionType from './actionTypes';
import * as Constants from '../../../../../SharedModules/AppConstants';

const initialState = {
  details_error_msg: [],
  errorFieldList: {},
  left_table_data: [],
  right_table_data: [],
  drug_family_details: {},
  deleted_drugs: [],
  dup_NDC_data: [],
  disable_btns: true,
  tab_value: 'one',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.DRUG_FAMILY_DETAILS_DATA:
      return { ...state, drug_family_details: action.payload };
    case actionType.CREATE_NEW_FLAG:
      return { ...state, create_new_flag: action.payload };
    case actionType.DETAILS_ERROR_MSGS:
      return { ...state, details_error_msg: action.payload };
    case actionType.CONTRACTS_DATA:
      return { ...state, contract_data: action.payload };
    case actionType.TAB_VALUE:
      return { ...state, tab_value: action.payload };
    case actionType.DRUG_SEQ_NUM:
      return { ...state, drug_seq_num: action.payload };
    case actionType.DRUG_SEARCH_LIST:
      return { ...state, drug_search_list: action.payload };
    case actionType.DRUG_ROUTE_CODE_DROPDOWN:
      return { ...state, drug_route_code: action.payload };
    case actionType.DISPATCH_SEARCH_ELEMENTS:
      return { ...state, search_form_values: { ...action.payload } };
    case actionType.ALL_MANUFACTURER_DATA:
      return { ...state, all_manufacturer_data: action.payload };
    case actionType.ERROR_FIELD_LIST:
      return { ...state, errorFieldList: action.payload };
    case actionType.MAINTAIN_RIGHT_TABLE_DATA:
      return { ...state, right_table_data: action.payload };
    case actionType.MAINTAIN_LEFT_TABLE_DATA:
      return { ...state, left_table_data: action.payload };
    case actionType.DETAILS_FORM_VALUES:
      return { ...state, details_form_values: action.payload };
    case actionType.NEW_MFG:
      return { ...state, new_mfg: action.payload };
    case actionType.NEW_STC:
      return { ...state, new_stc: action.payload };
    case actionType.UPDATE_ACTION_BIT:
      return { ...state, update_action_bit: action.payload };
    case actionType.DELETED_DRUGS:
      return { ...state, deleted_drugs: action.payload };
    case actionType.RESET_STORE:
      return initialState;
    case actionType.DISABLE_SAVE_CANCEL:
      return { ...state, disable_btns: action.payload };
    case actionType.DUP_NDC_DATA:
      return { ...state, dup_NDC_data: action.payload };
    case actionType.RESET_MAINTAIN_PAGE:
      return {
        ...state,
        details_error_msg: [],
        errorFieldList: {},
        left_table_data: [],
        disable_btns: true,
        search_form_values: { searchSelect: 'drugName', searchText: '' },
      };

    default:
      return state;
  }
};

export default reducer;
